import axios from 'axios'
import { WECHAT_LOGIN_API } from '@api/index'
import { WECHAT_MINI_LOGIN_API, MP_STATUS_BY_BRAND_ID } from './url.api'
import { getPlatform } from '@utils'
const { isWeixinMiniProgram } = getPlatform()

const { BRANDID } = Config
/** 会员相关API */
export default class ThirdAuthAPI {
  /**
  * 微信会员登录、注册、查询
  * @param {string} openid - 用户openid
  * @param {string} gAuthToken - 第三方授权的gAuthToken
  * @param {IMemberUserInfo} userInfo - 会员信息
  */
  static async wechatMiniLogin (openid: string, gAuthToken: string, userInfo: any): Promise<IMemberInfo & TError> {
    const res = await axios.post(WECHAT_MINI_LOGIN_API, {
      params: {
        openid,
        brandId: BRANDID,
        ...userInfo
      },
      headers: {
        token: gAuthToken
      }
    },
    ).catch((error) => {
      console.error('homePage接口报错 ', error)
      return {
        error: true,
        errorMsg: '获取会员信息失败'
      }
    }) as any
    return res.error ? res : res.result || {}
  }

  /**
  * 微信会员登录、注册、查询
  * @param {string} gAuthToken - 第三方授权的gAuthToken
  * @param {IMemberUserInfo} userInfo - 会员信息
  */
  static async wechatLogin (params: any): Promise<IMemberInfo & TError> {
    const { token, gOpenId, invitation, deviceInfo } = params
    const para: any = {
      brandId: BRANDID,
      channle: 'wechat',
      isWechatminiapp: isWeixinMiniProgram, // 是不是微信小程序
    }
    if (invitation) para.invitation = invitation
    if (deviceInfo) para.deviceInfo = deviceInfo
    if (gOpenId) para.gOpenId = gOpenId
    para.buildDate = window.buildinfo.buildDate // 编译时间
    const res = await axios.post(WECHAT_LOGIN_API, para, {
      headers: {
        token: token
      }
    },
    ).catch((error) => {
      console.error('wechatLogin接口报错', error)
      return {
        error: true,
        errorMsg: '获取会员信息失败'
      }
    }) as any
    return res.error ? res : res.result || {}
  }

  /**
  * 获取当前品牌是否需要公众号授权
  */
  static async getMpStatusByBrandId (): Promise<any & TError> {
    return await axios.get(MP_STATUS_BY_BRAND_ID, { timeout: 3000 }).catch(() => {}) as any
  }
}
